<template>
    <div>
        <Popup v-model="ischecked" :close-on-click-overlay="false">
            <div class="invitepopup">
                <div @click="toggleInvitedpopup" class="invitepopupclose">

                </div>
                <div class="invitepopupheader">
                    请输入团队邀请码
                </div>
                <div class="invitepopupbody">
                    <Field placeholder="请输入邀请码"  v-model="invitedcode"/>
                    <Button class="mvbutton" type="warning" round @click="checkInvitedCode">确定</Button>
                </div>
            </div>
        </Popup>
    </div>
</template>

<script>
  import './invitemember.less'
  import {findgroup} from '@/libs/api'
  import {setStorage, getStorage,removeStorage,goBack} from '@/libs/utils'
  import {Button,Popup,Field,Dialog} from 'vant'

  export default {
    name: 'invitemember',
    components: {
        Field,
        Button,
        Popup
    },
    data() {
        return {
            ischecked: true,
            invitedcode: '',
            matchid: '',
            urid: '',
            token: ''
        }
    },
    methods:{
        toggleInvitedpopup(){
            this.$router.go(-1);
        },
        checkInvitedCode(){
            if(!this.invitedcode)
            {
                Dialog({ message: '请输入团队邀请码' });
                return;
            }
            //groupcode
            findgroup({matchid:this.matchid,groupcode:this.invitedcode,urid:this.urid,token:this.token}).then((res)=>{
                if(res.status==200){
                    if(res.data.state==1)
                    {
                        //pages/match/member/edit
                        this.$router.replace({name:'adduser',params:{from:'share',rrid:res.data.rrid,rgid:res.data.rgid,categoryid:res.data.categoryid,matchid:res.data.matchid,typeid:res.data.typeid}});

                    }else{
                        Dialog({ message: '未找到对应的队伍,请检查输入的邀请码是否有误' });
                        return;
                    }
                }
            })
        }
    },
    mounted(options) {
        this.$nextTick(() => {
            this.matchid = this.$route.params.matchid
            let userinfo = getStorage('userInfo')
            this.urid = userinfo.urid
            this.token = userinfo.token
        })
    }

  }
</script>